const nyDateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
});

export function getLocalDate(dateString) {
    if (!dateString) return new Date();
    if (dateString instanceof Date) {
        if (isNaN(dateString.getTime())) return new Date();
        if (dateString.getUTCHours() === 0 && dateString.getUTCMinutes() === 0 && dateString.getUTCSeconds() === 0 && dateString.getUTCMilliseconds() === 0) {
            const iso = dateString.toISOString();
            const parts = iso.slice(0, 10).split('-');
            return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
        }
        return new Date(dateString.getFullYear(), dateString.getMonth(), dateString.getDate());
    }
    if (typeof dateString === 'string') {
        const trimmed = dateString.trim();
        // Plain date YYYY-MM-DD or midnight UTC
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed) || /^\d{4}-\d{2}-\d{2}T00:00:00(\.000)?Z?$/.test(trimmed)) {
            const parts = trimmed.slice(0, 10).split('-');
            return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
        }
    }
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return new Date();

    // Check if it's exact midnight UTC
    if (d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0 && d.getUTCMilliseconds() === 0) {
        const iso = d.toISOString();
        const parts = iso.slice(0, 10).split('-');
        return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    }

    // For Greenwich timestamps with non-zero time, evaluate in Eastern Time (America/New_York)
    const parts = nyDateFormatter.formatToParts(d);
    let y, m, day;
    for (const p of parts) {
        if (p.type === 'year') y = parseInt(p.value, 10);
        if (p.type === 'month') m = parseInt(p.value, 10) - 1;
        if (p.type === 'day') day = parseInt(p.value, 10);
    }
    return new Date(y, m, day);
}